var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"clack",rawName:"v-clack"}],style:({backgroundImage:'url(' + _vm.img + ')'}),attrs:{"id":"app"}},[_c('TheSideMove'),_vm._v(" "),_c('TheFooter'),_vm._v(" "),_c('TheGoTop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }